import React from 'react'

const QuoteGraphic = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="45"
      viewBox="0 0 27 45"
    >
      <g>
        <g>
          <path
            fill="#00a1ff"
            d="M17.638 20.394a14.91 14.91 0 0 0-4.035-.576c-2.039 0-3.74.456-5.06 1.013C9.817 16.28 12.872 8.424 18.958 7.54a1.436 1.436 0 0 0 1.179-1.017l1.33-4.652a1.386 1.386 0 0 0-.184-1.156A1.45 1.45 0 0 0 20.271.09C19.82.03 19.364 0 18.91 0 11.605 0 4.37 7.455 1.317 18.13-.475 24.393-1 33.81 3.414 39.735c2.47 3.316 6.074 5.087 10.711 5.264l.057.001c5.721 0 10.795-3.768 12.339-9.162a12.21 12.21 0 0 0-1.175-9.524c-1.662-2.886-4.4-4.99-7.708-5.92z"
          />
        </g>
      </g>
    </svg>
  )
}

export default QuoteGraphic
